import axios, { AxiosError, AxiosResponse } from 'axios';
import { UserToken } from '../authSlice';

interface BBOauthResponseData {
  access_token: string;
  refresh_token: string;
  expires_in: number; // 7200 // 2hours
  scopes: string; // pullrequest:write account snippet project runner issue team pipeline
  token_type: 'bearer';
  state: 'authorization_code';
}
interface BBOauthResponseError {
  error: string;
  error_description: string;
  message: string;
}

interface getNewTokenParams {
  code?: string,
  refresh_token?: string
  bb_client_id?: string
}

const getBBAuthToken = async (endpoint: string, endpointParams: getNewTokenParams): Promise<UserToken | void> => {
  const response: AxiosResponse<BBOauthResponseData> | void = await axios
    .get(`${endpoint}bbauth/token`, {
      params: {
        ...endpointParams
      }
    })
    .catch((error: AxiosError<BBOauthResponseError>) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }

      return Promise.reject({ 
        status: error.response?.status ?? 500,
        data: console.log(error.response?.data ?? "")
      })
    });

  if (!response) return;

  const { data } = response;

  return {
    token: data.access_token,
    expires: Date.now() + (data.expires_in ?? 7200) * 1000,
    refreshToken: data.refresh_token,
    service: "bitbucket",
    userGroup: "staff"
  };
}

export const fetchTokenWithCode = async (
  code: string
): Promise<UserToken | void> => {
  const endpoint = process.env.REACT_APP_RESOURCES_API_URL;
  if (!endpoint)
    throw Error('REACT_APP_RESOURCES_API_URL environment variable is not set.');

  const endpointParams:getNewTokenParams = {
    code,
    bb_client_id: process.env.REACT_APP_BB_CLIENT_ID
  }

  return getBBAuthToken(endpoint, endpointParams);
};

export const fetchTokenWithRefreshToken = async (
  refresh_token: string
): Promise<UserToken | void> => {
  const endpoint = process.env.REACT_APP_RESOURCES_API_URL;
  if (!endpoint)
    throw Error('REACT_APP_RESOURCES_API_URL environment variable is not set.');

  const endpointParams:getNewTokenParams = {
    refresh_token,
    bb_client_id: process.env.REACT_APP_BB_CLIENT_ID
  }

  return getBBAuthToken(endpoint, endpointParams);
};
